// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { ml } from 'styled-components-spacing';

export const StyledLogoWrapper = styled.a`
  ${ml(3)}

  flex: 0 0 auto;
  height: auto;

  cursor: pointer;

  ${breakpoint('desktop')`
    margin: auto;
    ${ml(3)}
    height: auto;
  `}
  ${breakpoint('largeDesktop')`
    ${ml(5)}
  `}
`;

export const StyledLogo = styled.img`
  width: 120px;

  ${breakpoint('desktop')`
    width: 150px;
  `}
`;
